module.exports = __webpack_public_path__ + "img/investment-plan.d081d606.webp";